<template>
  <v-menu
    :close-on-content-click="true"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
    :disabled="disabled"
  >
    <v-text-field
      slot="activator"
      :label="label"
      persistent-hint
      v-model="dateFormatted"
      @input="onInput"
      readonly
      :placeholder="placeholder"
      :clearable="clearable"
      :disabled="disabled"
    />
    <v-date-picker
      no-title
      :first-day-of-week="1"
      locale="ru-Ru"
      :value="currentValue"
      @input="onInput"
      :disabled="disabled"
    />
  </v-menu>
</template>

<script>

  /**
   *
   *
   */
  export default {

    name: 'DatePicker',

    /**
     *
     *
     */
    props: {

      // Необходимо для инициализации значения по умолчанию
      value: {

      },

      // Режим не указанной даты.
      clearable: {
        type: Boolean,
        required: false,
        default: false
      },

      // Название поля.
      label: {
        type: String,
        required: false,
        default: ''
      },

      //
      placeholder: {
        type: String,
        required: false,
        default: ''
      },

      //
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },

      //
      empty: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    /**
     *
     *
     */
    data() {

      return {

        //
        currentValue: null, // 'Не указано',

        //
        dateFormatted: ''
      }
    },

    /**
     * После создания компонента.
     *
     */
    created() {

      this.init()
    },

    /**
     *
     *
     */
    watch: {

      /**
       *
       *
       */
      currentValue: {

        handler( value ) {
          this.dateFormatted = this.formatDate( value )
        },

        // Необходимо для инициализации значения по умолчанию
        immediate: true
      },

      /**
       * Начальное значение времени.
       *
       */
      value: {

        handler( value ) {
          this.currentValue = value
        },

        // Необходимо для инициализации значения по умолчанию
        immediate: true
      },
    },

    /**
     *
     *
     */
    computed: {

    },

    /**
     *
     *
     */
    methods: {

      /**
       * Инициализация компонента.
       *
       */
      init() {

      },

      /**
       *
       *
       * @param value
       */
      onInput( value ) {
        this.dateFormatted = this.formatDate( value );
        this.$emit('input', value )
      },

      /**
       *
       *
       * @param date
       * @returns {*}
       */
      formatDate( date ) {

        if ( !date ) {
          return null
        }

        const [ year, month, day ] = date.split( '-' )

        return `${day}.${month}.${year}`
      },

      /**
       *
       *
       * @param date
       * @returns {*}
       */
      parseDate( date ) {

        if ( !date ) {
          return null
        }

        const [ month, day, year ] = date.split( '.' )

        return `${year}-${month.padStart( 2, '0' )}-${day.padStart( 2, '0' )}`
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/apps/bpm/components/DatePicker.vue